import { ROUTES_CONFIG } from "@/config/routes.config";
import { useUserStore } from "@/stores/user"
import { useTRPC } from "@/trpc";
import { TWhoami } from "@/types/trpc.types";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useAuth = () => {
    const navigate = useNavigate();
    const { trpc } = useTRPC();
    const setUser = useUserStore((s) => s.setUser);
    const setLogout = useUserStore((s) => s.logout);
    const user = useUserStore((s) => s.user);

    const { data, isLoading, isError } = useQuery({
        queryKey: ['whoami'],
        queryFn: async () => {
            return trpc.auth.whoami.query();
        },
        retry: false,
        refetchOnWindowFocus: false
    })

    useEffect(() => {
        if (data) setUser(data as TWhoami);
    }, [data, setUser]);

    const logout = () => {
        setLogout();
        trpc.auth.logout.mutate();
        navigate(ROUTES_CONFIG.AUTH.LOGIN.$buildPath({}), { replace:true })
    }

    return { user: data || user, isLoading, isError, logout };
}